"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChildLogger = require("./ChildLogger");
Object.keys(_ChildLogger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChildLogger[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ChildLogger[key];
    }
  });
});
var _LoggerApplicationInsightsConfig = require("./LoggerApplicationInsightsConfig");
Object.keys(_LoggerApplicationInsightsConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoggerApplicationInsightsConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoggerApplicationInsightsConfig[key];
    }
  });
});
var _LoggerTransportType = require("./LoggerTransportType");
Object.keys(_LoggerTransportType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoggerTransportType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoggerTransportType[key];
    }
  });
});
var _LoggerLike = require("./LoggerLike");
Object.keys(_LoggerLike).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoggerLike[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoggerLike[key];
    }
  });
});
var _LoggerMetadata = require("./LoggerMetadata");
Object.keys(_LoggerMetadata).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoggerMetadata[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoggerMetadata[key];
    }
  });
});
var _LoggerMetadataPrimitiveValue = require("./LoggerMetadataPrimitiveValue");
Object.keys(_LoggerMetadataPrimitiveValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoggerMetadataPrimitiveValue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoggerMetadataPrimitiveValue[key];
    }
  });
});
var _MessageMetadata = require("./MessageMetadata");
Object.keys(_MessageMetadata).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MessageMetadata[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MessageMetadata[key];
    }
  });
});
var _SeverityLevels = require("./SeverityLevels");
Object.keys(_SeverityLevels).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SeverityLevels[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SeverityLevels[key];
    }
  });
});
